export default "__VITE_ASSET__C$c8TwM4__"